<template>
  <div class="mt-2">
    <form data-vv-scope="comment-management">
      <vs-textarea
        class="mb-0"
        maxlength="255"
        label="Comentario"
        v-model="comment"
        name="comment"
        v-validate="{required: process === 'reject', min: 5}"
      />
      <div
        v-if="errors.first('comment-management.comment')"
        class="con-text-validation span-text-validation-danger
         vs-input--text-validation-span v-enter-to"
        style="height: 20px;">
        <span class="span-text-validation">
          {{errors.first('comment-management.comment')}}
        </span>
      </div>
    </form>
    <div class="my-2 text-right">
      <UploadFile
        permission="*"
        text="Agregar"
        v-model="file"
        :upload-to="urlFile"
        :maxSizeInMb="10"
        type-button="small"
        button-class=""
        container-class="text-right"
        @input="addAdditionalFile($event)"
      />
    </div>
    <div class="row">
      <div class="col-2" v-for="file in commentFiles" :key="file.id">
        <div class="d-flex flex-column align-items-center">
          <vs-icon icon="description" size="30px" color="primary" />
          <strong class="text-truncate w-100 text-center">
            {{ file.name }}
          </strong>
          <vs-button
            color="danger"
            type="flat"
            icon="clear"
            @click="removeAdditionalFile(file.id)"
          />
        </div>
      </div>
    </div>
    <b-overlay :show="loading">
      <div class="row">
        <div class="col-12 text-right">
          <b-button
            class="mr-2"
            data-cy="process-massive-button"
            variant="primary"
            size="sm"
            @click="sendAction"
          >
            {{`${action} documentos`}}
          </b-button>
        </div>
      </div>
    </b-overlay>
  </div>
</template>
<script>

import { mapActions } from 'vuex';

import UploadFile from '@/febos/global/_vue/componentes/UploadFile';

export default {
  name: 'ModalProcess',
  components: {
    UploadFile
  },
  data() {
    return {
      error: {
        message: ''
      },
      comment: '',
      file: {},
      commentFiles: [],
      loading: false
    };
  },
  computed: {
    urlFile() {
      const { flowId } = this.$route.params;
      return `febos-io/global/${process.env.VUE_APP_AMBIENTE}/empresas/aprobaciones/${flowId}/comentarios`;
    },
    action() {
      let buttonText = '';
      switch (this.process) {
        case 'sign':
          buttonText = 'Firmar';
          break;
        case 'approve':
          buttonText = 'Aprobar';
          break;
        case 'reject':
          buttonText = 'Rechazar';
          break;
        default:
          buttonText = 'Procesar';
          break;
      }
      return buttonText;
    }
  },
  methods: {
    ...mapActions('Approvals', [
      'processMassiveFiles'
    ]),
    cancelProcess() {
      this.comment = '';
      this.commentFiles = [];
    },
    async validateForm(scope) {
      const result = await this.$validator.validateAll(scope);
      return !!result;
    },
    makeObjectRequest() {
      let action = '';
      if (this.process) {
        switch (this.process) {
          case 'sign':
            action = 'firmar';
            break;
          case 'approve':
            action = 'aprobar';
            break;
          case 'reject':
            action = 'rechazar';
            break;
          default:
            console.log('no tiene');
            break;
        }
      }

      const body = {
        accion: 'cl_aprobaciones',
        nombre: 'APROBACIÓN Masiva de documentos',
        metodo: 'SERIE',
        ejecutarDeInmediato: 'N',
        comunes: {
          comentario: {
            accion: action,
            comentario: this.comment
          },
          documentos: this.commentFiles.map((file) => ({
            tipo: action,
            nombre: file.name,
            adjuntoId: file.id,
            adjuntoUrl: file.path,
            adjuntoMime: file.mime,
            adjuntoEstado: 2
          })),
          pais: 'cl',
          functionClass: 'cl.febos.aprobaciones.acciones.flujo.masiva.HandlerClAprobacionesProcesarFlujoMasiva',
          requestClass: 'cl.febos.aprobaciones.acciones.flujo.masiva.RequestClAprobacionesProcesarFlujoMasiva',
          responseClass: 'cl.febos.aprobaciones.acciones.flujo.masiva.ResponseClAprobacionesProcesarFlujoMasiva'
        },
        payload: this.selectedFlows.map((flow) => ({
          requestAprobacion: {
            estado: action.toUpperCase(),
            pasoId: flow.pasoActualId,
            ejecucionId: flow.idAprobacion,
            aprobacionId: '0',
            temporalContinuar: false,
            temporalUsuario: '',
            temporalUsuarioId: ''
          }
        }))
      };

      return { body };
    },
    async sendAction() {
      const isValid = await this.validateForm('comment-management');
      if (!isValid) {
        return;
      }

      this.loading = true;
      const response = await this.processMassiveFiles(this.makeObjectRequest());
      this.$bvToast.toast(
        `${response.mensaje}`,
        {
          title: '¡Genial!',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          noAutoHide: true
        }
      );
      this.comment = '';
      this.commentFiles = [];
      this.loading = false;
      this.$emit('close-modal');
    },
    commitAction(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.sendAction();
    },
    async addAdditionalFile(event) {
      if (!Object.keys(this.file).length) {
        return;
      }

      if (this.file.failed || event.failed) {
        this.$vs.dialog({
          color: 'danger',
          title: 'Ups!',
          text: `${event.failedMessage || 'La carga del archivo falló, inténtalo de nuevo'}`,
          acceptText: 'Ok'
        });
        return;
      }

      this.commentFiles.push(this.file);
      await this.$validator.reset();
    },
    removeAdditionalFile(fileId) {
      this.commentFiles = this.commentFiles.filter((file) => file.id !== fileId);
    },
    mounted() {
      this.comment = '';
      this.commentFiles = [];
    }
  },
  props: {
    process: { type: String, required: true },
    selectedFlows: { type: Array, required: true },
  }
};
</script>
